import { storeToRefs } from 'pinia';
import { useColorSchemeStore } from './color-scheme-store';
import type { ColorScheme } from './color-schemes';
import { computed } from 'vue';

export function useColorScheme() {
    const store = useColorSchemeStore();

    const { loading, scheme, next, auto, system } = storeToRefs(store);

    const set = (nextScheme: ColorScheme | 'auto' | null | undefined) =>
        store.set(nextScheme);
    const reset = () => store.reset();
    const wait = () => store.wait();

    const modelValue = computed({
        get: () => (auto.value ? null : next.value),
        set: (newValue) => {
            if (!newValue) {
                reset();
            } else {
                set(newValue);
            }
        },
    });

    return {
        scheme,
        loading,
        next,
        auto,
        system,
        set,
        reset,
        wait,
        modelValue,
    };
}
